// refreshLock.ts
let refreshPromise: Promise<string> | null = null;

export const getNewAccess = () => refreshPromise;

export const lockRefresh = (p: Promise<string>) => {
    refreshPromise = p.finally(() => { refreshPromise = null; });
    return refreshPromise;
};
